import React, { useEffect, useRef, useState } from 'react';
import s from './s.module.less';

type Props = {
    children: React.ReactNode;
};

// The save actions stick to the bottom so they stay reachable on a long settings page, but a
// permanent background looks bolted on. The 1px sentinel below the bar tells us which state we are
// in: out of view means the bar is floating over content (frost it), in view means the page bottom
// is reached and the bar is resting where it belongs (leave it flat).
const StickyFooterActions: React.FC<Props> = ({ children }) => {
    const sentinelRef = useRef<HTMLDivElement>(null);
    const [stuck, setStuck] = useState(false);

    useEffect(() => {
        const sentinel = sentinelRef.current;
        if (!sentinel || typeof IntersectionObserver === 'undefined') {
            return undefined;
        }
        const observer = new IntersectionObserver(([entry]) => setStuck(!entry.isIntersecting), { threshold: 0 });
        observer.observe(sentinel);
        return () => observer.disconnect();
    }, []);

    return (
        <>
            <div className={`${s.footerActions} ${stuck ? s.footerActionsStuck : ''}`}>{children}</div>
            <div ref={sentinelRef} className={s.footerSentinel} aria-hidden />
        </>
    );
};

export default StickyFooterActions;
